import type { ReactNode } from 'react';

const shellClass =
  'light-app-page -mx-4 -mb-4 px-4 pb-8 pt-4 md:-mx-6 md:px-6 md:pb-10 md:pt-6 2xl:-mx-10 2xl:px-10 min-h-[calc(100vh-5rem)] rounded-xl border border-gray-200 bg-gray-50 text-gray-900 shadow-sm dark:border-gray-200 dark:bg-gray-50';

/**
 * Light gray page canvas for app routes (works in dark site theme).
 * Restores shadcn light-theme CSS variables so buttons, selects, and tabs stay readable.
 */
export function LightAppPageShell({ children }: { children: ReactNode }) {
  return <div className={shellClass}>{children}</div>;
}
